var _path, _path2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroadcast(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 4.9V7.1V20.3C0.666016 21.5133 1.76235 22.5 3.11046 22.5H20.2216C21.5697 22.5 22.666 21.5133 22.666 20.3V7.1V4.9C22.666 3.6867 21.5697 2.7 20.2216 2.7H17.7771V0.5H15.3327V2.7H7.99935V0.5H5.5549V2.7H3.11046C1.76235 2.7 0.666016 3.6867 0.666016 4.9ZM20.224 20.2999H3.11047V7.09986H20.2216L20.224 20.2999Z",
    fill: "url(#paint0_linear_1867_3389)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 4.9V7.1V20.3C0.666016 21.5133 1.76235 22.5 3.11046 22.5H20.2216C21.5697 22.5 22.666 21.5133 22.666 20.3V7.1V4.9C22.666 3.6867 21.5697 2.7 20.2216 2.7H17.7771V0.5H15.3327V2.7H7.99935V0.5H5.5549V2.7H3.11046C1.76235 2.7 0.666016 3.6867 0.666016 4.9ZM20.224 20.2999H3.11047V7.09986H20.2216L20.224 20.2999Z",
    fill: "#6F00DE",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1867_3389",
    x1: 0.666016,
    y1: 11.7683,
    x2: 22.666,
    y2: 11.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.642ddf84c2a9aa9b0d80d15a2e7f56a4.svg";
export { ForwardRef as ReactComponent };